import { render } from "./ShippingServicePreselectionEditor.vue?vue&type=template&id=4ede2fbd"
import script from "./ShippingServicePreselectionEditor.vue?vue&type=script&lang=js"
export * from "./ShippingServicePreselectionEditor.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__